module.exports = __webpack_public_path__ + "img/skiing001.1a0d37e1.jpg";